export default __webpack_public_path__ + "static/desktop_KV03-c211f19b1abb6e5352d9381f01cfd654.mp4";